import React from 'react';
import styled from  'styled-components';
import { toPounds } from './../../services/Formats';
import { ExternalLink } from './../../components/Form/ExternalLink';

const AskingQuestionsDiv  = styled.div`
  margin-bottom: 50px;
  p {
    font-family: 'Ubuntu',arial;
    font-size: 16px;
    color: #000;
    margin-top: 0px;
    margin-bottom: 3px;
    text-align: center;
    line-height: 1.5rem;
  }
  p.click-it { margin-top: 1.75rem; font-size: 14px; }
  a { color: #0a2f70; font-weight: bold; text-decoration: underline; }
  .pounds { color: #0a2f70; font-weight: bold; }
`;

export const AskingQuestions = ({ output, hideLink }) => (
  <AskingQuestionsDiv>
    {/*<p>*/}
    {/*  Asking*/}
    {/*  {hideLink ? <span> 13 questions </span> : <ExternalLink href='#'>13 questions</ExternalLink>}*/}
    {/*  could make {output.ltv.diff > 0 ? <span className='pounds'> {toPounds(output.ltv.diff)} </span> : false} difference*/}
    {/*  to your client.*/}
    {/*</p>*/}
    <p>Our Horizon plans offer a range of loan to value (LTV) options, from low to high with corresponding interest rates to suit different customer needs. Enter some basic information above to find out how much cash your client could release from their home.</p>
    {/*<p class="click-it">Click on the people below to see the type of medical circumstances which qualify for each level.</p>*/}
  </AskingQuestionsDiv>
);



// WEBPACK FOOTER //
// ./src/components/LtvCalculator/AskingQuestions.js